
import ChevronIcon from "../../assets/icons/chevronIcon";
import RangeDoubleSlider from "../../components/rangeSlider/rangeDoubleSlider";
import RangeSlider from "../../components/rangeSlider/rangeSlider";
import { InstrumentAmountDTOInstrumentEnum, PieceFilterDTO, PieceFilterDTOInstrumentationTypeEnum, PieceFilterResultDTO } from "../../openapi-generated-client";
import { formatEnumValue } from "../../utils/objectUtils";
import "./pieceFilter.css";
import PieceFilterChooseList from "./pieceFilterChooseList";
import PieceFilterCountryList from "./pieceFilterCountryList";
import PieceFilterElement from "./pieceFilterElement";
import PieceFilterInstrumentList from "./pieceFilterInstrumentList";

interface PieceFilterProps {
    body: PieceFilterDTO;
    setBody: (newBody: PieceFilterDTO) => void;
    filterResult: PieceFilterResultDTO;
    mobileExpand?: boolean;
    setMobileExpand?: (expand: boolean) => void;
}

export default function PieceFilter(props: PieceFilterProps) {

    return <div className={"sidebar piece-filter" + (props.mobileExpand != undefined ? " mobile" : "") + (props.mobileExpand ? " expanded" : "")}>
        <h2>Filters<span className="result-amount">{props.filterResult.totalAmount} Results</span>{props.mobileExpand != undefined ? <h5 className="collapse round-button" onClick={() => {
            if(props.setMobileExpand) {
                props.setMobileExpand(false);
            }
        }}>
            <ChevronIcon/>
        </h5> : <></>}</h2>
        
        <PieceFilterElement title="Type" active={props.body.original != undefined} setActive={(active) => {
            if(!active) {
                props.setBody({...props.body, original: undefined});
            } else {
                props.setBody({...props.body, original: true});
            }
        }}>
            <PieceFilterChooseList options={["Original", "Transcription"]} active={props.body.original ? 0 : 1} onClick={(v: number) => {
                props.setBody({...props.body, original: v === 0});
            }}/>
        </PieceFilterElement>
        <PieceFilterElement title="Difficulty" active={props.body.difficulties != undefined} setActive={(active) => {
            if(!active) {
                props.setBody({...props.body, difficulties: undefined});
            } else {
                props.setBody({...props.body, difficulties: []});
            }
        }}>
            <PieceFilterChooseList options={["Pedagogic", "Concert"]} active={props.body.difficulties ? props.body.difficulties[0] : -1
            } onClick={(v: number) => {
                props.setBody({...props.body, difficulties: [v]});
            }}/>
        </PieceFilterElement>
         <PieceFilterElement title="Instrumentation Type" active={props.body.instrumentationType != undefined} setActive={(active) => {
            if(!active) {
                props.setBody({...props.body, instrumentationType: undefined});
            }else {
                props.setBody({...props.body, instrumentationType: PieceFilterDTOInstrumentationTypeEnum.Solo, totalInstrumentAmount: undefined});
            }
        }}>
            <PieceFilterChooseList options={Object.values(PieceFilterDTOInstrumentationTypeEnum).map(v => formatEnumValue(v))} active={props.body.instrumentationType ? Object.values(PieceFilterDTOInstrumentationTypeEnum).indexOf(props.body.instrumentationType) : -1} onClick={(v: number) => {
                props.setBody({...props.body, instrumentationType: Object.values(PieceFilterDTOInstrumentationTypeEnum)[v]});
            }}/>

        </PieceFilterElement>
        <PieceFilterElement hidden={props.body.instrumentationType === PieceFilterDTOInstrumentationTypeEnum.Solo} title="Instruments" active={props.body.instruments != undefined} setActive={(active) => {
            if(!active) {
                props.setBody({...props.body, instruments: undefined, totalInstrumentAmount: undefined});
            }else {
                props.setBody({...props.body, instruments: [
                    {
                        instrument: InstrumentAmountDTOInstrumentEnum.Accordion,
                        amount: 1
                    }
                ], totalInstrumentAmount: undefined});
            }
        }}>
            <PieceFilterInstrumentList instrumentAmount={props.body.totalInstrumentAmount ? props.body.totalInstrumentAmount : -1} setInstrumentAmount={(v: number) => {
                if(v == 0) {
                    props.setBody({...props.body, totalInstrumentAmount: undefined});
                }else {
                    props.setBody({...props.body, totalInstrumentAmount: v});
                }
            }} maxElements={5} instruments={props.filterResult.instrumentsWithAmount} instrumentsChosen={props.body.instruments ? props.body.instruments : []} setInstrumentsChosen={(instruments) => props.setBody({...props.body, instruments})}/>
        </PieceFilterElement>
        <PieceFilterElement title="Duration" active={props.body.durationFrom != undefined || props.body.durationTo != undefined} setActive={(active) => {
            if(!active) {
                props.setBody({...props.body, durationFrom: undefined, durationTo: undefined});
            } else {
                props.setBody({...props.body, durationFrom: 0, durationTo: props.filterResult.maxPossibleDuration});
            }
        }}>
            <RangeDoubleSlider checkTitle={(value: number) => {
                if(value == 0) return "<1 - {value2} min";
            }} title={"{value1} - {value2} min"} onUpdateRight={(v: number) => {
                props.setBody({...props.body, durationTo: v});
            }} onUpdateLeft={(v: number) => {
                props.setBody({...props.body, durationFrom: v});
            }} offset={2} min={0} max={props.filterResult.maxPossibleDuration} step={1} defaultLeft={2} defaultRight={props.filterResult.maxPossibleDuration > 8 ? 8 : props.filterResult.maxPossibleDuration}/>
        </PieceFilterElement>
        <PieceFilterElement title="Year of creation" active={props.body.yearFrom != undefined || props.body.yearTo != undefined} setActive={(active) => {
            if(!active) {
                props.setBody({...props.body, yearFrom: undefined, yearTo: undefined});
            } else {
                props.setBody({...props.body, yearFrom: 1300, yearTo: new Date().getFullYear()});
            }
        }}>
            <RangeDoubleSlider title={"{value1} - {value2}"} onUpdateRight={(v: number) => {
                props.setBody({...props.body, yearTo: v});
            }} onUpdateLeft={(v: number) => {
                props.setBody({...props.body, yearFrom: v});
            }} offset={2} min={1300} max={new Date().getFullYear()} step={1} defaultLeft={1300} defaultRight={new Date().getFullYear()}/>
        </PieceFilterElement>
        <PieceFilterElement title="Price" active={props.body.maxPrice != undefined} setActive={(active) => {
            if(!active) {
                props.setBody({...props.body, maxPrice: undefined});
            } else {
                props.setBody({...props.body, maxPrice: props.filterResult.maxPossiblePrice});
            }
        }}>
            <RangeSlider default={0} min={0} max={props.filterResult.maxPossiblePrice} step={0.25} checkTitle={(value: number) => {
                if(value == 0) return "free";
            }} title={"up to {value}€"} onUpdate={(v: number) => {
                props.setBody({...props.body, maxPrice: v});
            }}/>
        </PieceFilterElement>
        <PieceFilterElement title="Countries" active={props.body.composerCountries != undefined} setActive={(active) => {
            if(!active) {
                props.setBody({...props.body, composerCountries: undefined});
            } else {
                props.setBody({...props.body, composerCountries: []});
            }
        }}>
            <PieceFilterCountryList maxElements={5} countries={props.filterResult.countries} countriesChosen={props.body.composerCountries ? props.body.composerCountries : []} setCountriesChosen={(countries) => props.setBody({...props.body, composerCountries: countries})}/>
        </PieceFilterElement>
    </div>;
}